import React from 'react';
import { render } from 'react-dom';

import 'modernizr';
import 'lazysizes/plugins/respimg/ls.respimg.js';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes';

import DataActions  from './actions/DataActions';

import App from './views/App/App';
import Home from './views/Home/Home';
import Work from './views/Work/Work';
import About from './views/About/About';
import NotFound from './views/NotFound/NotFound';
import Loader from './components/Loader/Loader';
import CSSTransitionRoute from './components/CSSTransitionRoute/CSSTransitionRoute';

import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom';

class RegisDesign {

  shouldRender404(location) {
    switch (location.pathname.split('/')[1]) {
      case '':
      case 'about':
      case 'work':
        return false;
      default:
        return true;
    }
  }

  init() {
    render(
      <Loader>
        <Router>
          <App>
            <Route render={({ location }) => (
              <main>
                <CSSTransitionRoute
                  transitionName="fade"
                  exact
                  path="/"
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={200}
                  component={Home}
                />
                <CSSTransitionRoute
                  transitionName="fade-slide"
                  path="/about"
                  transitionEnterTimeout={400}
                  transitionLeaveTimeout={400}
                  component={About}
                />
                <CSSTransitionRoute
                  transitionName="slide"
                  path="/work/:project"
                  transitionEnterTimeout={400}
                  transitionLeaveTimeout={400}
                  component={Work}
                />
                { this.shouldRender404(location)
                  ? <NotFound />
                    : null
                }
              </main>
            )}/>
          </App>
        </Router>
      </Loader>
      , document.getElementById('regisDesign')
    );
  }
}

new RegisDesign().init();



// WEBPACK FOOTER //
// ./src/index.js